const moment = require('moment');
const {fsMomentImport, genHash} = require("../utils/utils");
const Address = require("../utils/Address");
const TimeFrame = require("../utils/TimeFrame");
const {FALLBACK_MONTHLY_PRICE} = require("./RentalConstant");
const File = require("../file/File");
const QuantityOption = require("../rentOption/QuantityOption");

class Rental {

    constructor({
                    id = genHash(10),
                    monthlyPrice = FALLBACK_MONTHLY_PRICE,
                    deliveryTimeFrame = new TimeFrame(),
                    deliveryDate = moment().add(1, 'week'),
                    car = null,
                    carID = '',

                    created = moment(),
                    createdBy = '',
                    updated = moment(),
                    updatedBy = '',

                    deposit = 0,
                    overDraftKilometerPrice = 0,
                    returnTimeFrame = new TimeFrame(),
                    expectedReturnDate = null,
                    actualReturnDate = null,
                    shippingAddress = null,
                    returnAddress = null,

                    rentOption = QuantityOption.fromFirestore(QuantityOption.DEFAULT_OPTION),
                    file = [],
                } = {}) {


        this.id = id;
        this.monthlyPrice = monthlyPrice;
        this.deliveryTimeFrame = new TimeFrame(deliveryTimeFrame);
        this.returnTimeFrame = new TimeFrame(returnTimeFrame);

        this.car = car;
        this.carID = carID;
        this.createdBy = createdBy;
        this.updatedBy = updatedBy;
        this.deposit = deposit;
        this.overDraftKilometerPrice = overDraftKilometerPrice;

        this.deliveryDate = null;
        this.created = null;
        this.updated = null;
        this.expectedReturnDate = null;
        this.actualReturnDate = null;

        const field = ['deliveryDate', 'created', 'updated', 'expectedReturnDate', 'actualReturnDate'];
        [deliveryDate, created, updated, expectedReturnDate, actualReturnDate].forEach((date, index) => {
            date = fsMomentImport(date)
            this[field[index]] = date && date.isValid() ? date : null

        })
        this.returnAddress = returnAddress ? returnAddress : null;
        this.shippingAddress = shippingAddress ? shippingAddress : null;
        this.file = Array.isArray(file) ? file : [];

        this.rentOption = rentOption;
    }

    static get FS_COLLECTION_NAME() {
        return 'rental'
    }

    validate(attribute) {

        if (attribute === undefined) {
            const attributes = Object.keys(this);
            try {
                attributes.map(attribute => {
                    if (!this._validate(attribute)) {
                        throw "validation error"
                    }
                });
            } catch (e) {
                return false
            }
            return true
        }

        return this._validate(attribute)
    }

    _validate(attribute) {

        try {
            switch (attribute) {
                case 'id':
                    return (typeof this[attribute] === 'string');
                default:
                    return false
            }
        } catch (e) {
            console.error('Validating Rental with error:', e, attribute);
            return false
        }
    }

    toFirestore() {

        const file = {}, rentOption = {};

        try {
            Object.keys(this.rentOption).forEach((key) => {
                if (this.rentOption[key].toFirestore) {
                    rentOption[key] = this.rentOption[key].toFirestore()
                }
            })
            this.file.forEach((f) => file[f.id] = f.toFirestore());
        } catch (e) {
            console.log('Could not convert files or rentOption')
        }


        return {
            version: 1,
            monthlyPrice: this.monthlyPrice,
            deliveryTimeFrame: this.deliveryTimeFrame.toFirestore ? this.deliveryTimeFrame.toFirestore() : null,
            deliveryDate: this.deliveryDate.toDate ? this.deliveryDate.toDate() : null,
            carID: this.carID,
            createdBy: this.createdBy,
            updatedBy: this.updatedBy,
            created: this.created.toDate ? this.created.toDate() : null,
            updated: this.updated.toDate ? this.updated.toDate() : null,
            deposit: this.deposit,
            overDraftKilometerPrice: this.overDraftKilometerPrice,
            returnTimeFrame: this.returnTimeFrame.toFirestore ? this.returnTimeFrame.toFirestore() : null,
            expectedReturnDate: this.expectedReturnDate && this.expectedReturnDate.toDate ? this.expectedReturnDate.toDate() : null,
            actualReturnDate: this.actualReturnDate && this.actualReturnDate.toDate ? this.actualReturnDate.toDate() : null,
            shippingAddress: this.shippingAddress && this.shippingAddress.toFirestore ? this.shippingAddress.toFirestore() : null,
            returnAddress: this.returnAddress && this.returnAddress.toFirestore ? this.returnAddress.toFirestore() : null,
            file,
            rentOption
        }
    }

    static versionConverter(rental){
        if(!rental.version){
            if (rental.car.rentOption){
              return {
                  ...rental,
                  rentOption: rental.car.rentOption,
                  version: 1,
              }
            }
        }
        return rental
    }


    static parseFirestore(rental, key ) {
        return new Rental({
            ...rental,
            shippingAddress: Address.parseFirestore(rental.shippingAddress),
            returnAddress: Address.parseFirestore(rental.returnAddress),
            deliveryTimeFrame: TimeFrame.parseFirestore(rental.deliveryTimeFrame),
            returnTimeFrame: TimeFrame.parseFirestore(rental.returnTimeFrame),
            file: Object.values(File.fromFirestore(rental.file)),
            rentOption: rental.rentOption ? QuantityOption.fromFirestore(rental.rentOption) : {},
            id: key ? key : rental.id,
        })
    }

    static fromFirestore(fsSnap, car = {}) {

        let data = {};
        if (fsSnap) {
            Object.keys(fsSnap).forEach((key) => {
                // the firestore object is not null
                if (fsSnap[key]) {
                    data[key] = Rental.parseFirestore({
                        ...fsSnap[key],
                        car: car[fsSnap[key].carID] ? car[fsSnap[key].carID] : null,
                    }, key)
                }
            });
        }

        return data
    }

    isSame(object) {

        return Object.is(
            JSON.stringify(object),
            JSON.stringify(this))
    }
}

module.exports = Rental;